import { lazy } from "react";
import { Navigate, Outlet, Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { MfaPolicyGate } from "@/components/MfaPolicyGate";
import ProviderLayout from "@/layouts/ProviderLayout";
import { useAuth } from "@/context/AuthContext";

const ProviderDashboard = lazy(() => import("@/pages/provider/ProviderDashboard"));
const ProviderInmateChart = lazy(() => import("@/pages/provider/ProviderInmateChart"));
const InmateCrisisProfile = lazy(() => import("@/pages/institution/InmateCrisisProfile"));const RxManagerPage = lazy(() => import("@/pages/provider/RxManagerPage"));
const EncounterEditorPage = lazy(() => import("@/pages/provider/EncounterEditorPage"));
const AppointmentsPage = lazy(() => import("@/pages/provider/AppointmentsPage"));
const ClinicalRecordsPage = lazy(() => import("@/pages/provider/ClinicalRecordsPage"));
const ProviderEmploymentPage = lazy(() => import("@/pages/provider/ProviderEmploymentPage"));
const ProviderMedicaidPage = lazy(() => import("@/pages/provider/ProviderMedicaidPage"));
const ProviderCaseloadPage = lazy(() => import("@/pages/provider/ProviderCaseloadPage"));
const ProviderMATPage = lazy(() => import("@/pages/provider/ProviderMATPage"));
const ProviderPreReleasePage = lazy(() => import("@/pages/provider/ProviderPreReleasePage"));
const SickCallReviewsPage = lazy(() => import("@/pages/provider/SickCallReviewsPage"));
const VerbalOrdersPage = lazy(() => import("@/pages/provider/VerbalOrdersPage"));
const ProviderDietOrdersPage = lazy(() => import("@/pages/provider/ProviderDietOrdersPage"));
const ProviderWatchPage = lazy(() => import("@/pages/provider/ProviderWatchPage"));
const ProviderTimePage = lazy(() => import("@/pages/provider/ProviderTimePage"));
const ProviderCoverage = lazy(() => import("@/pages/provider/ProviderCoverage"));
const ProviderStandingOrdersPage = lazy(() => import("@/pages/provider/ProviderStandingOrdersPage"));
const ProviderComplianceAttestationsPage = lazy(() => import("@/pages/provider/ProviderComplianceAttestationsPage"));
const ProviderMasterProtocolsPage = lazy(() => import("@/pages/provider/ProviderMasterProtocolsPage"));
const ProviderADAPage = lazy(() => import("@/pages/provider/ProviderADAPage"));
const MessagesPage = lazy(() => import("@/pages/MessagesPage"));
const SecurityPage = lazy(() => import("@/pages/SecurityPage"));

const CaseManagerRestrictedRoute = () => {
    const { user } = useAuth();
    return user?.case_manager ? <Navigate to="/provider/medicaid" replace /> : <Outlet />;
};

export function ProviderRoutes() {
    return (
        <Route
            path="/provider"
            element={
                <ProtectedRoute roles={["provider"]}>
                    <MfaPolicyGate><ProviderLayout /></MfaPolicyGate>
                </ProtectedRoute>
            }
        >
            <Route path="medicaid" element={<ProviderMedicaidPage />} />
            <Route path="caseload" element={<ProviderCaseloadPage />} />
            <Route path="pre-release" element={<ProviderPreReleasePage />} />
            <Route element={<CaseManagerRestrictedRoute />}>
                <Route index element={<ProviderDashboard />} />
                <Route path="mat" element={<ProviderMATPage />} />
                <Route path="sick-call-reviews" element={<SickCallReviewsPage />} />
                <Route path="verbal-orders" element={<VerbalOrdersPage />} />
                <Route path="diet-orders" element={<ProviderDietOrdersPage />} />
                <Route path="watch" element={<ProviderWatchPage />} />
                <Route path="watch/:watchId" element={<ProviderWatchPage />} />
                <Route path="inmates/:id" element={<ProviderInmateChart />} />
                <Route path="inmates/:inmateId/crisis-profile" element={<InmateCrisisProfile />} />
                <Route path="rx/:inmateId" element={<RxManagerPage />} />
                <Route path="clinical-records" element={<ClinicalRecordsPage />} />
                <Route path="ada" element={<ProviderADAPage />} />
                <Route path="encounters/new" element={<EncounterEditorPage />} />
                <Route path="encounters/:encounterId" element={<EncounterEditorPage />} />
                <Route path="appointments" element={<AppointmentsPage />} />
                <Route path="employment" element={<ProviderEmploymentPage />} />
                <Route path="time" element={<ProviderTimePage />} />
                <Route path="coverage" element={<ProviderCoverage />} />
                <Route path="standing-orders" element={<ProviderStandingOrdersPage />} />
                <Route path="compliance-attestations" element={<ProviderComplianceAttestationsPage />} />
                <Route path="master-protocols" element={<ProviderMasterProtocolsPage />} />
                <Route path="messages" element={<MessagesPage />} />
                <Route path="security" element={<SecurityPage />} />
            </Route>
        </Route>
    );
}
